import { render } from "./LinkPopup.vue?vue&type=template&id=1b20c1da&scoped=true&ts=true"
import script from "./LinkPopup.vue?vue&type=script&lang=ts"
export * from "./LinkPopup.vue?vue&type=script&lang=ts"

import "./LinkPopup.vue?vue&type=style&index=0&id=1b20c1da&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b20c1da"]])

export default __exports__